import { ViewModelReference } from './common-types';

export class ToastService<TOptions> {
  messages: ToastMessage<TOptions>[] = [];
  finished: ToastMessage<TOptions>[] = [];

  show(message: ToastMessage<TOptions>) {
    this.messages.push(message);
  }

  dispose(message: ToastMessage<TOptions>) {
    this.finished.push(message);

    if (this.messages.every(m => this.finished.includes(m))) {
      this.messages.splice(0, this.messages.length);
      this.finished.splice(0, this.finished.length);
    }
  }
}

export interface ToastMessage<TOptions> {
  viewModel?: ViewModelReference;
  view?: string;
  model?: unknown;
  instruction?: TOptions;
}
